import { useParams } from "react-router";
import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { PARTNER_PATHS } from "~/team/constants/paths.constants";

export function PartnerContactNotFound() {
  const { partnerId } = useParams();

  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />

      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Contact not found</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            We couldn&apos;t find the contact you were looking for. Check the contact list to find the right contact, or
            try reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>
          <ButtonLink variant="default" to={partnerId ? PARTNER_PATHS.contactList(partnerId) : PARTNER_PATHS.root}>
            {partnerId ? "View Contacts" : "View Partners"}
          </ButtonLink>
        </ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}
